var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * CZNA-1409 — after a save creates a link A → B and B does not link back, the cataloguer is
 * offered the back link B → A. Confirming creates a change proposal of B (never a direct write,
 * not even for the national supervisor); declining creates nothing.
 *
 * CZNA-1507 — the target is named once (its heading, then its ID on its own), and what happens
 * is a list the eye can catch, not one paragraph repeating the target.
 *
 * Pure presentational — {@link useBackLinkOffers} owns the queue and the write.
 */
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, MessageBanner, Modal, Select } from '@folio/stripes/components';
import SaveOutcomeUnknownNotice from '../ProposalForm/SaveOutcomeUnknownNotice';
/** The field the proposal would add, the way a cataloguer reads a 5XX. */
export var backLinkPreview = function (offer, designation) {
    var _a;
    var control = designation ? 'r' : offer.backControl;
    return [
        offer.backTag,
        control ? "$w ".concat(control) : null,
        designation ? "$i ".concat(designation) : null,
        "$a ".concat((_a = offer.backHeading) !== null && _a !== void 0 ? _a : ''),
    ].filter(Boolean).join(' ');
};
export var BackLinkOfferModal = function (_a) {
    var offer = _a.offer, index = _a.index, total = _a.total, inFlight = _a.inFlight, error = _a.error, _b = _a.confirmDisabled, confirmDisabled = _b === void 0 ? false : _b, onConfirm = _a.onConfirm, onDecline = _a.onDecline;
    var intl = useIntl();
    var _c = useState(''), designation = _c[0], setDesignation = _c[1];
    var chosen = designation || null;
    var footer = (React.createElement("div", { style: { display: 'flex', justifyContent: 'flex-end', gap: '8px' } },
        React.createElement(Button, { onClick: onDecline, disabled: inFlight, "data-testid": "back-link-offer-decline" },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.backLinkOffer.decline" })),
        React.createElement(Button, { buttonStyle: "primary", onClick: function () { return onConfirm(chosen); }, disabled: inFlight || confirmDisabled, "data-testid": "back-link-offer-confirm" },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.backLinkOffer.confirm" }))));
    return (React.createElement(Modal, { open: true, label: intl.formatMessage({ id: 'ui-czna-authorities.backLinkOffer.heading' }, { index: index, total: total }), footer: footer, dismissible: true, onClose: function () { if (!inFlight)
            onDecline(); }, size: "medium", id: "back-link-offer-modal" },
        React.createElement("div", { "data-testid": "back-link-offer" },
            error && (React.createElement(MessageBanner, { type: "error" }, typeof error === 'string' ? error : (React.createElement(SaveOutcomeUnknownNotice, { failure: error, runVerify: function (verify) { return verify(); } })))),
            React.createElement("p", null,
                React.createElement("strong", { "data-testid": "back-link-offer-target" }, offer.targetHeading),
                offer.targetAuthorityId && (React.createElement(React.Fragment, null,
                    offer.targetHeading ? ' · ' : null,
                    React.createElement("span", { "data-testid": "back-link-offer-target-id" }, offer.targetAuthorityId)))),
            React.createElement("ul", null,
                React.createElement("li", null,
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.backLinkOffer.notLinkedBack" })),
                React.createElement("li", null,
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.backLinkOffer.proposalForReview" })),
                React.createElement("li", null,
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.backLinkOffer.targetUnchanged" }))),
            offer.designations.length > 0 && (React.createElement(Select, { label: intl.formatMessage({ id: 'ui-czna-authorities.backLinkOffer.designation.label' }), value: designation, onChange: function (e) { return setDesignation(e.target.value); }, disabled: inFlight, dataOptions: __spreadArray([
                    { value: '', label: intl.formatMessage({ id: 'ui-czna-authorities.backLinkOffer.designation.none' }) }
                ], offer.designations.map(function (d) { return ({ value: d, label: d }); }), true), "data-testid": "back-link-offer-designation" })),
            React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.backLinkOffer.preview" }),
                ' ',
                React.createElement("code", { "data-testid": "back-link-offer-preview" }, backLinkPreview(offer, chosen))))));
};
export default BackLinkOfferModal;
